import { connectPagination } from 'react-instantsearch-dom';
import qs from 'qs';

import useMediaQuery from '../../../hooks/useMediaQuery';

import LinkButton from '../../../components/buttons/LinkButton';

import classes from './Pagination.module.css';

const Pagination = ({ currentRefinement, nbPages, refine }) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const { match: matchMobile } = useMediaQuery('(min-width: 768px)');
    
    const createURL = (page) => {
        const currentSearch = typeof window !== 'undefined' ? window.location.search : '';
        const parsedParams = qs.parse(currentSearch.replace('?', ''), { comma: true });
        
        const updatedParams = { ...parsedParams, page: page };
        
        const queryString = qs.stringify(updatedParams, { arrayFormat: 'comma', encodeValuesOnly: true });
        
        return `${currentPath}?${queryString}`;
    };

    const generatePaginationItems = () => {
        const around = 3;
        const range = [];
        const rangeWithDots = [];

        const start = Math.max(1, currentRefinement - around);
        const end = Math.min(nbPages, currentRefinement + around);

        for (let i = start; i <= end; i++) {
            range.push(i);
        }

        if (start > 1 && currentRefinement === 1) {
            if (start > 2) {
                rangeWithDots.push(1);
                rangeWithDots.push('...');
            } else {
                rangeWithDots.push(1);
            }
        } else if (start > 2) {
            rangeWithDots.push('...');
        }

        range.forEach((page) => rangeWithDots.push(page));

        if (end < nbPages && currentRefinement === nbPages) {
            if (end < nbPages - 1) {
                rangeWithDots.push('...');
                rangeWithDots.push(nbPages);
            } else {
                rangeWithDots.push(nbPages);
            }
        } else if (end < nbPages - 1) {
            rangeWithDots.push('...');
        }

        return rangeWithDots;
    };

    const paginationItems = generatePaginationItems();

    return (
        <div className={classes.root}>
            {currentRefinement > 1 && (
                <LinkButton
                    href={createURL(1)}
                    onClick={() => refine(1)}
                    className={classes.paginationLink}
                >
                    «
                </LinkButton>
            )}
            {currentRefinement > 1 && (
                <LinkButton
                    className={classes.paginationLink}
                    href={createURL(currentRefinement - 1)}
                    onClick={() => {
                        refine(currentRefinement - 1);
                    }}
                    rel="prev"
                >
                    {matchMobile ? "Vorige" : "‹"} 
                </LinkButton>
            )}
            {
                paginationItems.map((item, index) => {
                    if (item === '...') {
                        return (
                            <span 
                                key={`ellipsis-${index}`} 
                                className={classes.ellipsis}
                            >
                                ...
                            </span>
                        );
                    }

                    const page = item;
                    return (
                        <LinkButton
                            className={`${classes.paginationLink} ${page === currentRefinement ? classes.active : ''}`}
                            key={page}
                            href={createURL(page)}
                            onClick={() => refine(page)}
                        >
                            {page}
                        </LinkButton>
                    );
                })
            }
            {!(currentRefinement === nbPages) && (
                <LinkButton
                    className={classes.paginationLink}
                    href={createURL(currentRefinement + 1)}
                    onClick={() => refine(currentRefinement + 1)}
                    rel="next"
                >
                    {matchMobile ? "Volgende" : "›"} 
                </LinkButton>
            )}
            {!(currentRefinement === nbPages) && (
                <LinkButton
                    className={classes.paginationLink}
                    href={createURL(nbPages)}
                    onClick={() => refine(nbPages)}
                >
                    »
                </LinkButton>
            )}
        </div>
    );
};

export default connectPagination(Pagination);